import axios, { AxiosResponse } from 'axios';
import { cacheBuster } from '@/common/helpers';
import { TokenResponse } from '@/types/TokenResponse';
import { IUser } from '@/types/User';
import { apolloClient } from '@/apollo';
import { userQuery } from '@/graphql/queries/session.queries';
import { SessionResponse } from '@/types/SessionResponse';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export function getSession(force: boolean) {
  return axios
    .get(`/get/settings/session?${cacheBuster(force)}`)
    .then((value: AxiosResponse<SessionResponse>) => value.data);
}

export function getToken() {
  return axios.get('/get/settings/token').then((value: AxiosResponse<TokenResponse>) => value.data);
}

const getUser = async (): Promise<IUser> => {
  const {
    data: { me },
  } = await apolloClient.query({
    query: userQuery,
    fetchPolicy: EFetchPolicy.NetworkOnly,
  });
  return {
    firstName: me.firstName,
    lastName: me.lastName,
    fullName: `${me.firstName} ${me.lastName}`,
    id: me.id,
    email: me.email,
    thumbUrl: me.thumbUrl,
    title: me.title,
    mobile: me.mobile,
    nbrDocumentsSent: me.nbrDocumentsSent,
    registrationCampaign: me.registrationCampaign,
  };
};

export default {
  getUser,
};
